import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { AlertCircle, GraduationCap, ShoppingBag, MessageCircle } from 'lucide-react';

interface Props {
  open: boolean;
  email: string;
  onClose: () => void;
  onCreateAccount: () => void;
}

export function EmailNotRegisteredModal({ open, email, onClose, onCreateAccount }: Props) {
  return (
    <Dialog open={open} onOpenChange={(v) => !v && onClose()}>
      <DialogContent className="max-w-md sm:max-w-lg p-0 overflow-hidden gap-0 bg-card border-border">
        <div className="mobile-native-scroll max-h-[85vh] overflow-y-auto">
          <DialogHeader className="px-6 pt-6 pb-4 text-left space-y-3">
            <div className="flex items-center gap-3">
              <div className="w-11 h-11 rounded-xl bg-amber-500/10 flex items-center justify-center flex-shrink-0">
                <AlertCircle className="w-6 h-6 text-amber-500" />
              </div>
              <div className="min-w-0">
                <DialogTitle className="font-display font-semibold text-lg leading-tight">
                  E-mail não encontrado
                </DialogTitle>
                <DialogDescription className="text-xs text-muted-foreground mt-0.5 truncate">
                  {email}
                </DialogDescription>
              </div>
            </div>
            <p className="text-sm text-muted-foreground leading-relaxed">
              Não encontramos nenhum cadastro na ForjaHub com esse e-mail. Veja o que pode estar acontecendo:
            </p>
          </DialogHeader>

          <div className="px-6 pb-6 space-y-3">
            {/* Bloco 1 — Já é aluno */}
            <div className="rounded-xl border border-primary/20 bg-primary/5 p-4 space-y-2">
              <div className="flex items-center gap-2">
                <GraduationCap className="w-4 h-4 text-primary flex-shrink-0" />
                <h3 className="font-semibold text-sm text-foreground">Já é aluno da Forja?</h3>
              </div>
              <p className="text-sm text-muted-foreground leading-relaxed">
                Você provavelmente comprou usando um <strong className="text-foreground">e-mail diferente</strong> desse.
              </p>
              <div className="flex items-start gap-2 mt-2 p-3 rounded-lg bg-background/60 border border-border/50">
                <MessageCircle className="w-4 h-4 text-emerald-500 flex-shrink-0 mt-0.5" />
                <p className="text-xs text-muted-foreground leading-relaxed">
                  Seu acesso original foi enviado por <strong className="text-foreground">WhatsApp</strong> para o número que você cadastrou na hora da compra. Procure por mensagens da ForjaHub no seu WhatsApp.
                </p>
              </div>
            </div>

            {/* Bloco 2 — Quer comprar conta TikTok */}
            <div className="rounded-xl border border-border bg-muted/30 p-4 space-y-2">
              <div className="flex items-center gap-2">
                <ShoppingBag className="w-4 h-4 text-primary flex-shrink-0" />
                <h3 className="font-semibold text-sm text-foreground">Quer comprar uma conta TikTok?</h3>
              </div>
              <p className="text-sm text-muted-foreground leading-relaxed">
                Se você ainda não é aluno e só quer comprar uma conta no marketplace, basta criar um cadastro com esse e-mail.
              </p>
              <Button onClick={onCreateAccount} className="w-full mt-2" size="sm">
                Criar conta com {email.length > 22 ? 'este e-mail' : email}
              </Button>
            </div>

            <Button variant="ghost" onClick={onClose} className="w-full">
              Tentar outro e-mail
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
